import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

// ====== Inline Styles ======
const formStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "14px",
};
  
const rowStyle = {
  display: "flex",
  gap: "20px",
  flexWrap: "wrap",
};

const groupStyle = {
  flex: "1",
  display: "flex",
  flexDirection: "column",
  gap: "5px",
 
};

const actionStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "10px",
};

const btnStyle = {
  padding: "8px 18px",
  border: "none",
  borderRadius: "8px",
  background: "#1921a4",
  color: "#fff",
  cursor: "pointer",
  fontSize: "13px",
  marginLeft: "6px",
};

// ====== Component ======
function ProductForm() {
  const formik = useFormik({
    initialValues: {
      productName: "Nutrilite Daily",
      company: "",
      barcode: "",
      composition: "",
      productForm: "",
      location: "",
      productCategory: "",
      saleQty: false,
    },
    validationSchema: Yup.object({
      company: Yup.string().required("*Required"),
    }),
    onSubmit: (values) => {
      console.log("Submitted:", values);
    },
  });

  // ✅ Dynamic input style based on value
  const getInputStyle = (field, isError) => ({
    padding: "8px",
    borderRadius: "5px",
    border: `1px solid ${isError ? "red" : "#dedede"}`,
    fontSize: formik.values[field] ? "15px" : "13px",
    color: formik.values[field] ? "#000000ff" : "#333",
    backgroundColor: "#fff",
    transition: "all 0.2s ease-in-out",
    width: "100%",
  });

  // ✅ Lighter placeholder globally
  const placeholderStyle = `
    ::placeholder {
      color: #aaa;
      opacity: 1;
    }
  `;

  return (
    <>
      {/* Inject placeholder color styling */}
      <style>{placeholderStyle}</style>

      <form style={formStyle} onSubmit={formik.handleSubmit}>
        {/* Product Name */}
        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>
            Product Name <span style={{ color: "red" }}>*</span>
          </label>
          <select
            name="productName"
            style={getInputStyle("productName")}
            value={formik.values.productName}
            onChange={formik.handleChange}
          >
            <option value="Nutrilite Daily">Nutrilite Daily</option>
            <option value="Omega 3">Omega 3</option>
            <option value="Protein Powder">Protein Powder</option>
          </select>
        </div>

        {/* Company and Barcode */}
        <div style={rowStyle}>
          <div style={groupStyle}>
            <label style={{ fontSize: "14px" }}>
              Company <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              name="company"
              placeholder="Type or Press Space Bar"
              style={getInputStyle(
                "company",
                formik.touched.company && formik.errors.company
              )}
              value={formik.values.company}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.company && formik.errors.company && (
              <div style={{ color: "red", fontSize: "11px" }}>
                {formik.errors.company}
              </div>
            )}
          </div>

          <div style={groupStyle}>
            <label style={{ fontSize: "14px" }}>
              Barcode <span style={{ color: "#888" }}>(Optional)</span>
            </label>
            <input
              type="text"
              name="barcode"
              placeholder="Press Space to Scan"
              style={getInputStyle("barcode")}
              value={formik.values.barcode}
              onChange={formik.handleChange}
            />
          </div>
        </div>

        {/* Composition */}
        <div style={groupStyle}>
          <label style={{ fontSize: "14px" }}>
            Composition (Ex. Pracetamol 650mg){" "}
            <span style={{ color: "#888" }}>(Optional)</span>
          </label>
          <input
            type="text"
            name="composition"
            placeholder="Type or Press Space Bar"
            style={getInputStyle("composition")}
            value={formik.values.composition}
            onChange={formik.handleChange}
          />
        </div>

        {/* Product Form & Location */}
        <div style={rowStyle}>
          <div style={groupStyle}>
            <label style={{ fontSize: "14px" }}>
              Product Form <span style={{ color: "#888" }}>(Optional)</span>
            </label>
            <input
              type="text"
              name="productForm"
              placeholder="Type or Press Space"
              style={getInputStyle("productForm")}
              value={formik.values.productForm}
              onChange={formik.handleChange}
            />
          </div>

          <div style={groupStyle}>
            <label style={{ fontSize: "14px" }}>
              Location <span style={{ color: "#888" }}>(Optional)</span>
            </label>
            <input
              type="text"
              name="location"
              placeholder="Enter Location Here"
              style={getInputStyle("location")}
              maxLength="10"
              value={formik.values.location}
              onChange={formik.handleChange}
            />
            <span style={{ fontSize: "11px", color: "#888" }}>
              {formik.values.location.length}/10
            </span>
          </div>
        </div>

        {/* Product Category & Sale Qty */}
        <div style={rowStyle}>
          <div style={groupStyle}>
            <label style={{ fontSize: "14px" }}>
              Product Category <span style={{ color: "#888" }}>(Optional)</span>
            </label>
            <input
              type="text"
              name="productCategory"
              placeholder="Type or Press Space"
              style={getInputStyle("productCategory")}
              value={formik.values.productCategory}
              onChange={formik.handleChange}
            />
          </div>

          <div style={groupStyle}>
            <label style={{ fontSize: "14px" }}>
              Sale qty <span style={{ color: "#888" }}>(Optional)</span>
            </label>
            <div
              style={{
                ...getInputStyle("saleQty"),
                display: "flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: "#fff",
                cursor: "pointer",
              }}
              onClick={() =>
                formik.setFieldValue("saleQty", !formik.values.saleQty)
              }
            >
              <input
                type="checkbox"
                name="saleQty"
                checked={formik.values.saleQty}
                onChange={formik.handleChange}
                style={{
                  width: "16px",
                  height: "16px",
                  cursor: "pointer",
                  accentColor: "#1921a4",
                }}
              />
              <span style={{ fontSize: "13px", color: "#333" }}>
                Enable Loose Billing
              </span>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default ProductForm;
